import React, { useContext } from 'react'
import { LanguageContext } from '../../container/Language'
import EmailForm from './EmailForm'

const Contact = () => {
    const { dictionary: { contact: { form: { title, input }, coordinate } } } = useContext(LanguageContext)
    return (
        <div className="card-inner contacts" id="contacts-card">
            <div className="card-wrap">

                <div className="content contacts">

                    <div className="title">{title}</div>
                    <div className="content contacts">
                        <EmailForm input={input} />
                    </div>
                    <div className="title">{coordinate.title}</div>
                    <div className="row">
                        <div className="col col-d-12 col-t-12 col-m-12 border-line-v">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2631.818236242837!2d1.3616551927515588!3d48.72806469735226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e15546e7cf3aa7%3A0xda1678f9b03f6cce!2s24%20Av.%20Marceau%2C%2028100%20Dreux!5e0!3m2!1sen!2sfr!4v1690123679406!5m2!1sen!2sfr" width="600" height="450" style={{ border: '0' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        <div className="clear"></div>
                    </div>

                </div>



            </div>
        </div>
    )
}

export default Contact